import { Component, OnDestroy, AfterViewInit} from '@angular/core'

import { InsaMainService, LocalizeService } from '../../../insa-services';
import { MainWindowSearchCriteriaModel } from '../../../insa-models';

@Component({
  templateUrl: 'mainWindowSettings.component.html',
  selector: 'settings-widget'
})

export class MainWindowSettings implements OnDestroy, AfterViewInit {
  private today = new Date();
  private searchCriteria: MainWindowSearchCriteriaModel = {
    Portfolio: '',
    ChoosePortfolio: false,
    CustodyNumber: '',
    CustodyNumberList: ['1', '2'],
    FromDate: null,
    ToDate: null
  }

  constructor (private _localize: LocalizeService, private _insaMainService: InsaMainService) {
  }

  initDatePickers() {
    let pickersAnimation: kendo.ui.DatePickerAnimation = {};
    pickersAnimation.close = {};
    pickersAnimation.close.duration = 300;
    pickersAnimation.close.effects = "fadeOut zoom:out";
    pickersAnimation.open = {};
    pickersAnimation.open.duration = 300;
    pickersAnimation.open.effects = "fadeIn zoom:in";

    let pickerOptions: kendo.ui.DatePickerOptions = {};
    pickerOptions.animation = pickersAnimation;
    pickerOptions.format = "dd.MM.yyyy";
    pickerOptions.min = new Date(this.today.getFullYear(), 1, 1);
    pickerOptions.value = null;
    pickerOptions.culture = this._localize.getLocale(); 

    $("#FromDatePicker").kendoDatePicker(pickerOptions);
    $("#ToDatePicker").kendoDatePicker(pickerOptions);
  }

  initCustodyNumberDropdown() {
    let dropdownOptions: kendo.ui.DropDownListOptions = {};
    dropdownOptions.change = this.custodyNumberChange;
    dropdownOptions.dataSource = this.searchCriteria.CustodyNumberList;
    dropdownOptions.dataTextField = 'CustodyNumber';
    dropdownOptions.dataValueField = 'CustodyNumber';

    $('#custodyNumberDropdown').kendoDropDownList(dropdownOptions);

  }

  choosePortfolio () {
    // we send the true flag and set it back to false
    // INSA opens filtering window, user selects portfolio
    // ?
    // profit    
    this.searchCriteria.ChoosePortfolio = true;
    this._insaMainService.setMainWindowSearchCriteria(this.searchCriteria);
    this.searchCriteria.ChoosePortfolio = false;
  }

  custodyNumberChange (newCustody) {
    console.log('custodyNumberChange: ' + newCustody)
    this.searchCriteria.ChoosePortfolio = true;
    this._insaMainService.setMainWindowSearchCriteria(this.searchCriteria);
  }

  ngAfterViewInit () {
    this.initCustodyNumberDropdown();
    this.initDatePickers();
  }

  ngOnDestroy () {
  }

}



// WEBPACK FOOTER //
// ./app/insa-components/insa-main/insa-main-widgets/mainWindowSettings.component.ts